import { NectarIcon } from '@kluein/nectar';
import { ActionIcon } from '@mantine/core';
import { useLocation } from 'react-router-dom';

/**
 * Renders a floating Pendo Resource Center trigger button for non-Hatch routes.
 *
 * On Hatch routes (/next/*), returns null as the Help button in WorkspaceSidebar
 * already has the pendo-resource-centre ID.
 *
 * On all other routes, renders a 56x56px floating "Purple K" button
 */
const disableMonitorTools =
  import.meta.env.VITE_DISABLE_MONITOR_TOOLS === 'true';

const PendoResourceTrigger = () => {
  const location = useLocation();
  const isHatchRoute = location.pathname.startsWith('/next');

  if (isHatchRoute || disableMonitorTools) {
    return null;
  }

  const title = 'Open Resource Center';

  return (
    <ActionIcon
      id="pendo-resource-centre"
      size={56}
      radius="full"
      variant="filled"
      color="#6210EA"
      style={{
        position: 'fixed',
        bottom: 20,
        right: 20,
        zIndex: 19999,
        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.15)',
      }}
      aria-label={title}
      title={title}
    >
      <NectarIcon.KlueK size={32} />
    </ActionIcon>
  );
};

export default PendoResourceTrigger;
